module.exports = __webpack_public_path__ + "img/aggregate.045dbfaa.png";